import React, { ComponentType } from 'react'
import { Theme } from 'src/ui/style/Theme'
import { css } from 'src/ui/style/css'

export const Divider: ComponentType<{ vertical?: boolean }> = ({
    vertical = false
}) => (
    <div
        css={(th: Theme) => [
            css`
                background: ${th.colors.primary};
                width: ${vertical ? '1px' : 'auto'};
                height: ${vertical ? 'auto' : '1px'};
            `
        ]}
    />
)
